module.exports = __webpack_public_path__ + "static/media/gatsibo_model_village5.a543fe94.jpg";